module.exports = __webpack_public_path__ + "static/media/MX.5c990f49.jpg";